export const sum = (...numbers: number[]) => numbers.reduce((sum, num) => sum += num, 0)

/**
 * Calculates the referral savings amount for bundle pricing
 * @param onetimeCents - The one-time purchase price in cents
 * @param minCents - The minimum subscription price in cents  
 * @param discountCents - The referral discount amount in cents
 * @returns The savings amount in dollars (rounded)
 */
export const calculateReferralSavings = (onetimeCents: number, minCents: number, discountCents: number): number => {
  return Math.round((onetimeCents - (minCents - discountCents)) / 100)
}
